var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 797,
    viewBox: "0 0 852 797",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.754 352.14H717.926C718.123 352.14 718.518 352.14 718.716 351.942L741.424 329.256C741.621 329.058 741.621 328.861 741.621 328.466V326.296L715.754 352.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.475 478.595L565.291 477.411L547.52 495.166L548.704 496.349C548.704 496.349 548.704 496.349 548.902 496.547L566.475 478.595C566.475 478.792 566.475 478.595 566.475 478.595Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.008 361.807V359.242L691.467 363.779H694.034C694.231 363.779 694.231 363.779 694.429 363.779L696.008 362.201C696.008 362.004 696.008 362.004 696.008 361.807Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.214 290.787L748.73 284.277V282.698C748.73 282.304 748.532 282.106 748.532 281.712L739.449 290.787H742.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.56 439.534L767.093 77.3326C766.5 76.938 765.908 76.7407 765.118 76.7407H764.723L403.178 438.153L404.56 439.534Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.646 155.06L794.54 100.217H791.973H791.775L736.882 155.06H739.646Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.788 16.3739V13.6121L86.4551 515.485V518.247L588.788 16.3739Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.73 165.121L844.497 100.611C843.707 100.414 842.917 100.414 842.127 100.414H841.93L779.73 162.359V165.121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.642 382.521H587.406L646.051 323.929L644.669 322.548L584.642 382.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.37 330.242L650.988 328.861L597.279 382.521H600.044L652.37 330.242Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.097 290.787L667.969 311.698L668.166 311.895C668.561 312.29 669.153 312.684 669.746 312.882L689.097 293.549V290.787Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.65 305.385L663.23 306.766L689.097 280.923V278.161L661.65 305.385Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.696 457.683L447.211 482.145L447.408 482.343C447.803 482.737 448.396 483.132 448.988 483.329L471.696 460.642V457.683Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.483 382.521L658.293 336.752C658.096 336.16 657.899 335.569 657.306 334.977L609.719 382.521H612.483Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3409 320.773H92.5765L-18 431.248V434.01L95.3409 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.495 327.285L0.921875 462.734L2.3181 464.129L137.892 328.68L136.495 327.285Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.476 322.351L131.081 321.957C130.686 321.562 130.291 321.365 129.896 321.167L-5.3623 456.302L-3.9801 457.683L131.476 322.351Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.822 333.578L7.24805 469.028L8.64427 470.423L144.218 334.973L142.822 333.578Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.788 3.74842C588.788 2.95931 588.591 2.1702 588.196 1.57837L86.6523 502.663V505.424L588.788 3.74842Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.017 339.712L13.4434 475.161L14.8396 476.556L150.413 341.107L149.017 339.712Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7036 320.773H79.9392L-18 418.622V421.582L82.7036 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2637 320.773H67.3019L-18 406.194V408.956L70.2637 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.418 320.773H117.653L-11.6816 450.187L-10.2994 451.568L120.418 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.3 347.405H204.535L62.168 489.445H64.9324L207.3 347.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.937 347.405H216.975L74.8057 489.445H77.5701L219.937 347.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.1 0H577.336L85.665 491.023C86.06 491.615 86.2574 492.404 86.4549 492.996L580.1 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.145 347.208C156.553 347.011 155.961 346.616 155.368 346.222L19.9121 481.554L21.2943 482.935L157.145 347.208Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.025 347.405H179.261L37.0908 489.445H39.8552L182.025 347.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.662 347.405H191.898L49.5303 489.445H52.4921L194.662 347.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.696 448.017V445.058L440.893 475.833L442.275 477.214L471.696 448.017Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.983 288.617C728.983 289.406 729.378 290.195 729.971 290.392L743.595 276.78L742.213 275.399L728.983 288.617Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.983 276.188V278.95L735.105 272.637H732.34L728.983 276.188Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.422 313.079H682.186L689.097 305.977V303.215L679.422 313.079Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.116 352.14H705.881L741.423 316.63V313.868L703.116 352.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.664 341.29H688.899L683.963 346.221V348.983L691.664 341.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.88 471.005L541.147 488.721L542.544 490.116L560.276 472.4L558.88 471.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.795 186.822C805.992 186.624 806.387 186.427 806.585 186.23L850.815 141.842C851.013 141.645 851.21 141.25 851.408 141.053L805.795 186.822Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.963 358.847V361.609L741.423 304.004V301.242L683.963 358.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M792.565 187.413H795.33L852 130.795V128.033L792.565 187.413Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.597 155.06H775.781C776.176 155.06 776.769 155.06 777.164 155.257L832.254 100.217H829.49L774.597 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.322 155.06H752.284L806.98 100.217H804.216L749.322 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.959 155.06H764.723L819.617 100.217H816.852L761.959 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.73 174.985V177.747L851.21 106.332C851.013 105.741 850.618 105.149 850.223 104.557L779.73 174.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.112 186.23C781.705 186.624 782.297 187.019 782.889 187.216L852 118.169V115.407L781.112 186.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.733 317.616L638.351 316.235L519.086 435.588V438.35L639.733 317.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.862 218.456L509.798 394.358L511.194 395.753L687.258 219.85L685.862 218.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.955 470.901L471.695 435.391V432.629L434.573 469.52L435.955 470.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6264 320.773H54.862L-18 393.568V396.33L57.6264 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.211 292.957L650.593 294.338L689.098 255.671V252.909L649.211 292.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.414 311.304L632.032 309.923L519.086 422.962V425.724L633.414 311.304Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.293 304.991L625.911 303.61L519.086 410.337V413.098L627.293 304.991Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.892 286.644L644.274 288.025L689.097 243.243V240.481L642.892 286.644Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.697 297.297H732.735L728.983 301.242V304.004L735.697 297.297Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.529 299.072L656.911 300.65L689.097 268.297V265.535L655.529 299.072Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.215 416.255C602.808 415.663 603.203 414.874 603.4 414.282L573.781 443.874C574.571 443.677 575.163 443.282 575.756 442.887L602.215 416.255Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.244 155.06H727.009L786.049 96.0741L784.666 94.6931L724.244 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.111 406.869L566.138 438.813L567.534 440.208L599.508 408.264L598.111 406.869Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.693 389.228C580.101 388.636 579.903 388.044 579.706 387.452L519.086 448.017V450.778L580.693 389.228Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.011 395.541L585.629 394.16L552.653 426.908C553.443 426.908 554.036 427.105 554.825 427.697L587.011 395.541Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.784 400.575L559.811 432.52L561.207 433.915L593.18 401.97L591.784 400.575Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.617 111.264L267.721 259.025C267.524 260.8 266.142 262.181 264.364 262.378L239.09 287.63H241.854L417.197 112.448L415.617 111.264Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.775 269.613L128.417 284.957L129.813 286.352L145.172 271.008L143.775 269.613Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.438 282.179L141.079 297.524L142.475 298.919L157.834 283.574L156.438 282.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.679 275.399L318.666 72.5981C317.679 72.5981 316.889 72.9927 316.297 73.7818L235.339 154.665C234.549 155.455 233.759 155.849 232.772 155.849L112.915 275.596H115.679V275.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.677 223.515L401.993 77.3327V76.3463C401.993 75.7545 401.796 75.3599 401.598 74.7681L253.899 222.331C254.689 222.726 255.282 222.923 255.677 223.515Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.463 0H564.699L245.606 318.8V321.562L567.463 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.606 306.174V308.936L554.826 0H552.061L245.606 306.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.103 275.906L134.744 291.251L136.14 292.646L151.499 277.301L150.103 275.906Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.771 288.459L147.412 303.803L148.808 305.198L164.167 289.853L162.771 288.459Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.466 266.324L229.217 262.576C227.045 262.576 225.466 264.352 225.466 266.324Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.449 275.781L184.393 291.823L185.789 293.217L201.845 277.176L200.449 275.781Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.14 285.066C204.535 284.671 204.733 284.276 204.93 283.882L192.293 296.508C192.688 296.31 193.28 296.113 193.675 295.718L204.14 285.066Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.263 269.627L178.206 285.669L179.602 287.064L195.659 271.022L194.263 269.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.783 296.705C169.585 295.916 169.388 295.324 168.795 294.732L153.394 310.12C153.986 310.514 154.578 310.909 155.368 311.106L169.783 296.705Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.476 90.1558H159.712L79.5439 170.448V173.209L162.476 90.1558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.45 188.005L198.217 92.3258L197.23 91.3394C197.032 91.1421 196.835 91.1421 196.637 90.9448L99.6855 188.005H102.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.623 347.405L26.0332 487.867L26.4281 488.261C26.823 488.656 27.218 488.853 27.6129 489.05L169.585 347.405H166.623Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.451 46.7546L86.8506 527.717C87.048 528.308 87.2455 528.703 87.8379 529.097L88.0353 529.295L569.24 48.7274C568.648 48.1356 568.451 47.3465 568.451 46.7546Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.054 524.56L125.749 702.701C126.144 702.701 126.736 702.899 127.329 702.899H128.513L304.054 527.519V524.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.882 771.157L712.595 795.422C712.99 796.014 713.582 796.408 714.174 796.803L738.462 772.538C738.067 771.749 737.474 771.354 736.882 771.157Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9891 320.773H42.2247L-18 380.943V383.704L44.9891 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.123 607.417H686.728L567.266 726.769V727.558C567.266 728.15 567.266 728.742 567.463 729.334L688.9 608.008C688.505 607.614 687.913 607.417 687.123 607.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.347 515.683L512.372 517.655C512.372 518.05 512.57 518.642 512.964 519.036L513.359 519.431L517.111 515.683H514.347Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.855 262.576H238.893L225.466 276.188V278.95L241.855 262.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.751 90.1558H184.987L87.0479 188.005H89.8123L187.751 90.1558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.839 90.1558H147.075L79.5439 157.822V160.584L149.839 90.1558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.023 205.366L26.4277 298.875C26.8227 299.467 27.415 299.862 28.0074 300.256L122.985 205.366H120.023Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.349 90.1558L79.5439 182.876V184.06C79.5439 184.454 79.5439 185.046 79.7414 185.441L175.114 90.1558H172.349Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.214 320.773L-17.8027 443.479C-17.6053 443.874 -17.4078 444.466 -16.8154 444.86L-16.618 445.057L107.978 320.575H105.214V320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.973 565.791L574.769 580.981C574.966 581.179 575.361 581.179 575.558 581.179H577.335L592.737 565.791H589.973Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.841 138.686C212.236 138.489 212.828 138.291 213.223 137.7L225.663 125.271C226.058 124.877 226.255 124.482 226.65 123.89L211.841 138.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.892 116.225L203.881 134.22L205.277 135.615L223.288 117.62L221.892 116.225Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.158 169.264C156.751 169.658 157.146 170.053 157.54 170.645L216.975 111.264L215.593 109.883L156.158 169.264Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.637 154.074L49.9258 300.651H52.6902L198.217 155.257C197.427 155.06 197.032 154.468 196.637 154.074Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.848 144.999V142.237L157.936 180.114V182.876L195.848 144.999Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6396 275.399H90.4041L210.261 155.652H207.497L87.6396 275.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.762 188.005H127.526L210.853 104.951L209.274 103.571L124.762 188.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3518 320.773H29.5874L-18 368.317V371.276L32.3518 320.773Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.425 205.366H132.66L37.2881 300.651H40.0525L135.425 205.366Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.151 205.366H107.386L25.6387 287.038V289.8L110.151 205.366Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.277 275.399H103.042L222.899 155.652H220.134L100.277 275.399Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.125 188.005H115.087L204.535 98.6388L203.153 97.2578L112.125 188.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5438 254.488H45.7794L25.6387 274.413V277.174L48.5438 254.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9065 254.488H33.1421L25.6387 261.984V264.746L35.9065 254.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.295 262.576H251.531L227.046 287.039C227.638 287.433 228.428 287.63 229.02 287.828L254.295 262.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.242 85.0265V87.7884L517.111 0H514.347L429.242 85.0265Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.242 97.6522V100.414L529.748 0H526.984L429.242 97.6522Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.512 1.18366L430.427 72.2035C429.637 72.9926 429.242 73.979 429.242 74.9653V75.3599L504.474 0H504.079C503.289 0 502.302 0.394554 501.512 1.18366Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.242 110.081V112.843L542.386 0H539.424L429.242 110.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.195 278.555L123.578 280.134L331.303 72.4006H328.539L122.195 278.555Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.721 236.733L404.56 100.02L403.375 98.8359C403.375 98.8359 403.375 98.6387 403.177 98.6387L267.129 234.563C267.326 235.155 267.524 235.944 267.721 236.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.318 118.761C422.924 118.564 422.726 118.367 422.529 118.169L421.936 117.577L245.804 293.549V296.311L423.318 118.761Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.681 106.332L409.299 104.951L267.722 246.399V249.358L410.681 106.332Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.613 228.25L261.995 229.631L401.993 89.9584V86.9993L260.613 228.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.999 260.406L154.381 261.787L343.941 72.4006H341.176L152.999 260.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.636 273.032L167.018 274.413L369.018 72.4006H366.253L165.636 273.032Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.317 266.719L160.7 268.1L356.578 72.4006H353.616L159.317 266.719Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.954 279.344L173.336 280.725L191.7 262.181C191.7 261.984 191.897 261.984 192.095 261.787L230.402 223.515C230.599 223.318 230.797 223.318 230.797 223.12L381.655 72.4006H378.89L171.954 279.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46 222.331H244.224L394.292 72.4006H391.528L241.46 222.331Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.124 400.67L517.506 402.051L689.097 230.617V227.855L516.124 400.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.65 532.057V534.819L676.657 519.825H673.893L661.65 532.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.274 549.22L640.325 553.165H642.3C643.484 553.165 644.274 552.179 644.274 551.193V549.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.364 553.165L695.613 525.941L694.231 524.56L665.6 553.165H668.364Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.65 521.798V522.39L664.217 519.825H663.625C662.44 519.825 661.65 520.615 661.65 521.798Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.65 547.444L689.294 519.825C689.097 519.825 688.9 519.825 688.9 519.825H686.728L661.848 544.682V547.444H661.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.834 570.328V567.764V567.566L587.209 581.179H589.973L600.834 570.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.274 539.356V536.594L627.885 553.165H630.649L644.274 539.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.869 559.281L758.997 538.172V537.58C758.997 536.989 758.799 536.397 758.207 536.002L736.289 557.9L737.869 559.281Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.812 582.757H724.047L711.607 595.185V597.947L726.812 582.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.212 535.41H708.448L690.677 553.165H693.639L711.212 535.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.297 565.791C579.705 565.791 579.31 565.594 578.915 565.199L578.52 564.805L568.647 574.669L570.03 576.049L580.297 565.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.09 565.791C642.893 565.791 642.695 565.594 642.3 565.594H640.326L624.924 580.981H627.688L643.09 565.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.274 577.233V574.471L637.561 580.981H640.325L644.274 577.233Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.65 565.791H627.885L618.407 575.063V578.022L630.65 565.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.932 532.254L700.55 530.676L678.237 553.165H681.002L701.932 532.254Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.61 553.165H605.572L644.274 514.302V511.54L602.61 553.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.274 526.927V523.968L615.248 553.165H618.012L644.274 526.927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.935 553.165L643.88 502.268C643.485 501.873 642.892 501.479 642.3 501.479H641.905L590.171 553.165H592.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.131 558.336L562.218 568.24L563.614 569.635L573.527 559.731L572.131 558.336Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.955 533.323L537.042 543.228L538.438 544.622L548.351 534.718L546.955 533.323Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.294 520.757L524.381 530.661L525.777 532.056L535.69 522.152L534.294 520.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.62 527.05L530.707 536.954L532.103 538.349L542.016 528.445L540.62 527.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.616 544.091V546.852L632.032 501.281H629.267L586.616 544.091Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.282 539.616L543.369 549.52L544.765 550.915L554.679 541.011L553.282 539.616Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.609 545.909L549.695 555.813L551.092 557.208L561.005 547.304L559.609 545.909Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.077 474.057H646.842L654.74 466.166V463.404L644.077 474.057Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.936 552.203L556.022 562.107L557.419 563.502L567.332 553.597L565.936 552.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.351 467.153V469.914L654.74 453.54V450.779L638.351 467.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.351 454.527V457.289L651.58 444.071H648.816L638.351 454.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.072 618.464V615.702L571.215 735.45C571.807 735.844 572.4 736.239 572.992 736.436L691.072 618.464Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.277 641.94L766.895 640.559L682.976 724.402V727.164L768.277 641.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.213 646.742L684.413 735.461L685.809 736.856L774.609 648.137L773.213 646.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.401 653.175L690.601 741.893L691.997 743.288L780.797 654.57L779.401 653.175Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.272 663.641V660.879L696.996 748.075L698.378 749.456L784.272 663.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.666 606.233L752.284 604.852L641.312 715.722H644.077L753.666 606.233Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.22 615.308V612.546L653.949 715.722H656.714L757.22 615.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.22 627.933V625.171L666.587 715.722H669.351L757.22 627.933Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.959 635.627L760.577 634.246L679.026 715.722C679.816 715.722 680.606 715.919 681.198 716.511L761.959 635.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.272 676.266V673.504L703.314 754.388C703.907 754.783 704.697 755.177 705.289 755.177L784.272 676.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.614 795.816L738.264 784.177C739.054 783.388 739.449 782.401 739.449 781.415V781.021L723.455 797H723.85C725.035 797 726.022 796.605 726.614 795.816Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.371 771.354C713.384 771.749 712.594 772.538 712.199 773.524L714.371 771.354Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.206 770.959H724.442L712.002 783.388V786.347L727.206 770.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.272 701.518V698.756L727.799 755.177H730.563L784.272 701.518Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.272 688.892V686.13L715.162 755.177H717.927L784.272 688.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.02 627.144C694.231 627.144 693.441 626.947 692.848 626.355L581.877 737.225H584.641L695.02 627.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.806 564.016L743.99 565.199C743.99 565.199 744.188 565.199 744.188 565.396L759.195 550.601V547.839L742.806 564.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.589 553.165H730.958C731.156 553.165 731.156 553.165 731.353 553.165L749.125 535.41H746.36L728.589 553.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.878 445.847L662.045 194.713C661.65 194.121 661.452 193.332 661.452 192.543L409.496 444.268L410.878 445.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.314 553.165H706.276L723.85 535.41H721.086L703.314 553.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.907 587.294L733.525 585.913L711.607 607.811V610.573L734.907 587.294Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.545 599.92L746.163 598.539L628.873 715.722H631.637L747.545 599.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.469 565.791H756.431L758.998 563.226V560.267L753.469 565.791Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.226 593.607L739.844 592.226L711.607 620.437V623.199L741.226 593.607Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.354 515.88C528.959 515.683 528.761 515.683 528.366 515.683H526.984L518.296 524.363L519.678 525.744L529.354 515.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.002 585.124L714.174 582.954C712.989 583.349 712.397 584.138 712.002 585.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.65 628.525H627.885L567.266 689.089V691.851L630.65 628.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.461 627.144H704.696L594.317 737.422H597.082L707.461 627.144Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.855 607.417H674.09L567.266 714.144V716.905L676.855 607.417Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.287 628.328C642.892 628.525 642.497 628.525 642.102 628.525H640.325L567.266 701.518V704.28L643.287 628.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.951 553.165H718.716L736.487 535.41H733.722L715.951 553.165Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.833 335.174L369.215 336.358L655.727 50.3057H652.962L367.833 335.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.099 52.5632L374.302 341.3L375.699 342.695L664.496 53.9578L663.099 52.5632Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.502 355.691V355.099C362.502 354.507 362.304 353.915 362.107 353.521L310.57 405.01L311.953 406.391L362.502 355.691Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.42 58.8543L380.623 347.591L382.02 348.986L670.817 60.2488L669.42 58.8543Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.329 351.153H326.564L291.614 386.071L292.996 387.452L329.329 351.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.966 351.153H339.201L297.933 392.384L299.315 393.765L341.966 351.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.829 348.321L285.414 379.708L286.81 381.102L318.225 349.716L316.829 348.321Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.603 351.153H351.838L304.251 398.5L305.633 400.078L354.603 351.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.355 331.82H361.12L643.09 50.3057H640.326L358.355 331.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34 360.82L266.537 361.017L267.722 362.201L580.101 50.3057H577.336L266.34 360.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.641 331.82H323.405L605.375 50.3057H602.413L320.641 331.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.543 379.561L249.358 378.378L249.161 378.18L92.9717 534.227L94.3539 535.608L250.543 379.561Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.718 331.82H348.482L630.452 50.3057H627.688L345.718 331.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.08 331.82H336.042L617.815 50.3057H615.05L333.08 331.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.658 367.133L274.04 368.514L306.029 336.555C305.634 334.385 307.213 331.82 309.978 331.82H310.768L592.738 50.3057H589.973L272.658 367.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.859 406.588V409.35L729.774 76.7407H727.009L396.859 406.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.057 431.445C397.254 432.037 397.452 432.432 398.044 433.023L398.241 433.221L755.048 76.7407H752.284L397.057 431.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.859 419.214V421.976L742.411 76.7407H739.646L396.859 419.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.97 155.06H701.932L773.411 83.4483L772.029 82.0674L698.97 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.836 199.808L415.655 450.759L417.051 452.154L668.232 201.203L666.836 199.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.607 155.06H714.372L779.73 89.7613L778.348 88.3804L711.607 155.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.163 206.101L421.982 457.052L423.379 458.447L674.56 207.496L673.163 206.101Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.747 65.1492L386.95 353.886L388.347 355.281L677.144 66.5437L675.747 65.1492Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.859 393.962V396.922L717.334 76.7407H714.372L396.859 393.962Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.494 342.048L279.079 373.434L280.475 374.829L311.89 343.443L310.494 342.048Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.501 367.922V365.555L317.086 410.928C317.876 411.323 318.666 411.52 319.455 411.323L362.501 368.317C362.501 368.317 362.501 368.119 362.501 367.922Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.076 71.4433L393.278 360.18L394.675 361.575L683.473 72.8379L682.076 71.4433Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.859 368.908V371.67L692.059 76.7407H689.295L396.859 368.908Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.859 381.337V384.296L704.696 76.7407H701.932L396.859 381.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.016 436.18L305.634 434.799L117.456 623.001V625.763L307.016 436.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.054 539.948V536.989L138.189 702.701H141.151L304.054 539.948Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.288 422.174C472.485 421.976 472.485 421.779 472.683 421.582L501.907 392.385C502.104 392.187 502.302 391.99 502.499 391.99L680.804 213.651L679.422 212.271L428.255 463.207L429.637 464.588L472.288 422.174Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.723 589.662C329.328 589.267 328.736 588.873 328.143 588.873H327.551L282.136 634.246V637.008L329.723 589.662Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.316 601.696V598.934L282.334 646.872V649.634L330.316 601.696Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.74 605.641V602.879L150.826 702.702H153.591L250.74 605.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.74 618.267V615.505L163.464 702.701H166.228L250.74 618.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.741 630.892V628.131L176.102 702.701H178.866L250.741 630.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.876 588.873H315.112L282.334 621.621V624.383L317.876 588.873Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.705 433.813V431.051L519.086 460.642V463.404L548.705 433.813Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.704 446.438V443.479L522.245 469.914L523.627 471.295L548.704 446.438Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.704 459.064V456.105L528.563 476.227L529.946 477.608L548.704 459.064Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.316 614.321V611.559L282.334 659.3V662.26L330.316 614.321Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.316 639.573V636.614L297.933 668.967H300.697L330.316 639.573Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.316 626.947V623.988L285.296 668.967H288.06L330.316 626.947Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.054 514.697V513.907C304.054 512.921 304.449 511.935 305.239 511.146L354.406 462.023C354.801 461.629 354.998 461.234 355.196 460.84L118.443 697.375C118.838 697.967 119.036 698.559 119.431 699.151L304.054 514.697Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.939 411.126L280.556 409.745L117.456 572.696V575.458L281.939 411.126Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.257 417.439L286.875 416.058L117.456 585.124V588.083L288.257 417.439Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.895 429.867L299.512 428.486L117.456 610.376V613.138L300.895 429.867Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.576 423.554L293.194 422.173L117.456 597.75V600.512L294.576 423.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.659 390.726L105.421 546.821L106.817 548.216L263.055 392.121L261.659 390.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.854 397.139L111.616 553.234L113.012 554.629L269.25 398.534L267.854 397.139Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.456 562.832L275.62 404.813L274.238 403.432L117.456 560.07C117.456 560.267 117.456 560.465 117.456 560.465V562.832Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.272 419.214H346.31L117.456 648.056V650.818L349.272 419.214Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.686 464.866L534.954 482.582L536.35 483.976L554.082 466.261L552.686 464.866Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.59 425.527V423.16C355.59 422.962 355.59 422.765 355.59 422.765L117.456 660.681V663.443L355.59 425.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.59 450.581V447.819L117.456 685.736V688.498L355.59 450.581Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.59 438.153V435.391L117.456 673.307V676.069L355.59 438.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.331 384.433L99.0938 540.528L100.49 541.923L256.728 385.828L255.331 384.433Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.334 442.493L311.952 441.112L117.456 635.43V638.389L313.334 442.493Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.3d2ff8f7.svg";
export { ForwardRef as ReactComponent };